import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';
import timeTrackingService from '../../services/time-tracking.service';

interface LiveTimerProps {
  checkInTime: string;
  totalBreakTime: string;
}

export const LiveTimer: React.FC<LiveTimerProps> = ({ checkInTime, totalBreakTime }) => {
  const [elapsed, setElapsed] = useState('0h 0m');

  useEffect(() => {
    const updateTimer = () => {
      const time = timeTrackingService.calculateElapsedTime(checkInTime, totalBreakTime);
      setElapsed(time);
    };

    // Update immediately
    updateTimer();

    // Update every second
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [checkInTime, totalBreakTime]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px 20px',
        background: 'var(--glass)',
        border: '1px solid var(--glass-border)',
        borderRadius: '12px'
      }}
    >
      <Clock style={{ width: 24, height: 24, color: 'var(--accent-primary, #6366f1)' }} />
      <div>
        <p style={{ fontSize: '0.75rem', color: 'var(--text-tertiary, #9ca3af)', margin: 0 }}>
          Arbeitszeit heute
        </p>
        <p
          style={{
            fontSize: '1.5rem',
            fontWeight: 700,
            color: 'var(--text-primary, #374151)',
            margin: 0,
            lineHeight: 1.2
          }}
        >
          {elapsed}
        </p>
      </div>
    </div>
  );
};
